export const language: any = {
    LabelFavorites: "Favoriten",
    LabelYouDontHaveRecipeAddYourFavoriteRecipe: `Sie haben noch keine Lieblingsgerichte.<br/>Fügen Sie Ihre Lieblingsgerichte hinzu!`,
    LabelDoYouWantUnSave: `Möchten Sie dieses Rezept nicht mehr speichern?`,
    save: "Speichern",
    unsave: "Speichern",
    OkFavorite: "Ja",
    CloseFavorite: "Nein",
};

